import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Button } from '@ui-propulsion/react-components';
import styles from './partnerHeader.module.scss';
import { ctaTheme } from '../../utils/util';

export default function PartnerHeader({
  lcLogo = {},
  cta = null,
  partnerLogo = null,
  partnerLogoText = '',
  theme = '',
}) {
  const [isShow, setShow] = React.useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [ctaThemes, setCtaThemes] = useState(styles.redOutline);

  useEffect(() => {
    if (cta?.ctaTheme) setCtaThemes(ctaTheme(cta?.ctaTheme));
  }, [cta]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.document.documentElement.scrollTop < 25 ||
        window.scrollY < 25
      ) {
        setShow(false);
      } else {
        setShow(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <>
      <header
        className={`${styles.header} ${
          theme === 'blue' ? styles.dark : styles.light
        }`}
      >
        <div className={styles.wrapper}>
          <div className={styles.lcLogoContainer}>
            <a href={lcLogo.link}>
              <img
                className={styles.lcLogo}
                src={lcLogo.src}
                alt={lcLogo.alt}
                loading="lazy"
                {...{
                  ...(lcLogo.width && {
                    width: lcLogo.width,
                  }),
                  ...(lcLogo.height && {
                    height: lcLogo.height,
                  }),
                }}
              />
            </a>
          </div>
          {isShow && cta && (
            <div className={styles.ctaContainer}>
              <Button
                aria-label="Read More Reviews "
                variant="tertiary"
                fullWidth
                className={`${styles.cta} ${ctaThemes}`}
                href={cta.link}
              >
                {cta.label}
              </Button>
            </div>
          )}
          {partnerLogo && (
            <div className={styles.partnerContainer}>
              <div className={styles.partnerLogoText}>
                <p>{parse(partnerLogoText)}</p>
              </div>
              <div className={styles.partnerLogoContainer}>
                <img
                  className={styles.partnerLogo}
                  src={partnerLogo.src}
                  alt={partnerLogo.alt}
                  loading="lazy"
                  {...{
                    ...(partnerLogo.width && {
                      width: partnerLogo.width,
                    }),
                    ...(partnerLogo.height && {
                      height: partnerLogo.height,
                    }),
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </header>
      <div className={styles.contentPadding} />
    </>
  );
}

PartnerHeader.propTypes = {
  lcLogo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  cta: PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
  }),
  partnerLogoText: PropTypes.string,
  partnerLogo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  theme: PropTypes.string,
};
